import type { PersonalizationVariable } from './index'

export const detectVariables = (
  content: string,
  variables: PersonalizationVariable[],
  isHTML: boolean = false,
): PersonalizationVariable[] => {
  const regex = isHTML ? /data-variable="([\w-]+)"/g : /\{\{(\w+)\}\}/g

  const matches = content.match(regex) ?? []
  const detectedKeys = matches.map((m: string) =>
    m.replace(isHTML ? /data-variable="|"$/g : /\{\{|\}\}/g, ''),
  )

  return [...new Set(detectedKeys)]
    .map((key) => variables.find((pv) => pv.key === key))
    .filter((v): v is PersonalizationVariable => v !== undefined)
}
